import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import Registration from '../pages/Registration.vue';
import NewProposal from '../pages/NewProposal.vue';
import ResetPassword from '../pages/ResetPassword.vue';
import PersonalData from '../pages/PersonalData.vue';
import MyProposals from '../pages/MyProposals.vue';
// import Expert from '../pages/Expert.vue';
import ExpertGrid from '../pages/ExpertGrid.vue';
import Bs from '../pages/Bs.vue';
import RegisterFinish from '../pages/RegisterFinish.vue';
import NewLogin from '../pages/NewLogin.vue';
import Page404 from '../pages/404.vue';
import VerifyUser from '../pages/VerifyUser.vue'
import Dashboard from '../pages/Dashboard.vue'
import Pdf from '../pages/Pdf.vue'
import ModeratorTab2 from '../pages/ModeratorTab2.vue'
import ModeratorCouncilPage from '../pages/ModeratorCouncilPage.vue'
import Policy from '../pages/Policy.vue'
import Passes from '../pages/Passes.vue'
import Invitations from '../pages/Invitations.vue'
import Unsubscribe from '../pages/Unsubscribe.vue'
import References from '../pages/Reference.vue'
import Users from '../pages/Users.vue'



import NotFoundPage from '../components/Common/NotFoundPage.vue';

import { AUTH_URL, DOMEN } from '../../vars';
import SynchrotronCalendar from "../pages/SynchrotronCalendar.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: NewLogin,
    meta: { title: 'Вход' },
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe,
    meta: { title: 'Отписаться от рассылки' },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {title: 'Регистрация' },
  },
  {
    path: '/',
    name: 'Home',
    component: NewLogin,
    meta: { title: 'Вход' },
  },
  {
    path: '/register-finish/:email',
    name: 'RegisterFinish',
    component: RegisterFinish,
    props: true,
  },
  {
    path: '/user',
    name: 'MyProposals',
    component: MyProposals,
    meta: { requiresAuth: true, title: 'Мои заявки' },
  },
  {
    path: '/new-proposal/:id',
    name: 'NewProposal',
    component: NewProposal,
    meta: { requiresAuth: true, title: 'Новая заявка' },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: 'Восстановление пароля' },
  },
  {
    path: '/not-found',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: { title: 'Страница не найдена' },
  },
  {
    path: '/personal-data',
    name: 'PersonalData',
    component: PersonalData,
    meta: { requiresAuth: true, title: 'Личные данные' },
  },
  {
    path: '/passes',
    name: 'Passes',
    component: Passes,
    meta: { requiresAuth: true, title: 'Пропуска' },
  },
  {
    path: '/invitations',
    name: 'Invitations',
    component: Invitations,
    meta: { requiresAuth: true, title: 'Приглашения и справки' },
  },
  {
    path: '/privacy',
    name: 'Policy',
    component: Policy,
    meta: { requiresAuth: true, title: 'Политика в отношении обработки персональных данных' },
  },
  {
    path: '/references',
    name: 'References',
    component: References,
    meta: { requiresAuth: true, title: 'Справочники' },
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, title: 'Справочник Users' },
  },
  {
    path: '/expert-grid',
    name: 'ExpertGrid',
    component: ExpertGrid,
    meta: { requiresAuth: true, title: 'Эксперт' },
  },
  {
    path: '/bs',
    name: 'bs',
    component: Bs,
    children: [
      {
        path: '/bs/:id',
        name: 'bsId',
        component: Bs,
        meta: { requiresAuth: true, title: 'Станция' },
      }
    ],
    meta: { requiresAuth: true, title: 'Станция' },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, title: 'Статистика' },
  },
  {
    path: '/pdf/:id',
    name: 'pdf',
    component: Pdf,
    meta: { requiresAuth: true, title: 'Pdf' },
  },
  {
    path: '/moderator-tab-2',
    name: 'moderator-tab-2',
    component: ModeratorTab2,
    meta: { requiresAuth: true, title: 'ModeratorTab2', view: false },
  },
  {
    path: '/moderator-council',
    name: 'moderator-council',
    component: ModeratorCouncilPage,
    meta: { requiresAuth: true, title: 'ModeratorCouncil', view: false },
  },
  {
    path: '/verify-user',
    name: 'VerifyUser',
    component: VerifyUser
  },
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '/synchrotron-calendar',
    name: 'synchrotron',
    component: SynchrotronCalendar,
    meta: { title: 'Синхротрон - календарь' },
  },
  {
    path: '/reactor-calendar',
    name: 'reactor',
    component: SynchrotronCalendar,
    meta: { title: 'ИР-8 - календарь' },
  },
  {
    path: '*',
    redirect: '/404'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});
const DEFAULT_TITLE = 'KCSNR User Portal';
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  // console.log(from);
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = DOMEN + '/media/static/logo_black.png';
    document.getElementsByTagName('head')[0].appendChild(link);
  });
});
router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      const auth = await axios.get(`${AUTH_URL}profile/`, {
        headers: {
          Authorization: `Token ${localStorage.token}`,
        },
      });

      if (!auth) {
        next({
          path: '/login',
        });
      } else {
        next();
      }
    } else {
      next();
    }
  } catch (ex) {

    if (router.history.current.fullPath != '/login'){
      next({
        path: '/login',
      });
    }

  }
});

export default router;
